export default __webpack_public_path__ + "images/815f9ac57ca9584534bf0e11ff7bbf73-5_web_1919x543.jpg";